import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Form,
    Input,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
    TimePicker,
    Alert,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ColdTraceabilityApi from "../../Apis/ColdTraceabilityApi";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";
import StorageSelectColdTrace from "../../DropDowns/Stock/StorageSelectColdTrace";
import StorageListApi from "../../Apis/StorageListApi";
const { Title } = Typography;
function AddTemp({ visible, onClose, ProductctionDetails, storageUnit, ModalTemptype }) {
    const [formAdd] = Form.useForm();
    const navigate = useNavigate();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    if (ProductctionDetails) {
        formAdd.setFieldsValue({
            storageUnit: ProductctionDetails?.storageDTO?.id,
        });
    }
    const currentTime = moment().format("h:mm a");

    const [Correctvalid, setCorrectvalid] = useState(false);
    const handleInputChange = (event) => {
        const newItem = event.target.value.trim();
        console.log(newItem)
        // if (parseInt(ProductctionDetails?.storageDTO?.temperatureMinInCelsius) <= parseInt(newItem) && parseInt(ProductctionDetails?.storageDTO?.temperatureMaxInCelsius) >= parseInt(newItem)) {
        if (parseInt(storageUnit?.temperatureMinInCelsius) <= parseInt(newItem) && parseInt(storageUnit?.temperatureMaxInCelsius) >= parseInt(newItem)) {
            setCorrectvalid(false)
        } else {
            setCorrectvalid(true)
        }

    };

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    const [time, setTime] = useState(new Date());
    useEffect(() => {

    }, []);
    const intervalID = setInterval(() => {
        setTime(new Date());
    }, 1000);
    const formattedTimeNew = time.toLocaleTimeString();
   
    const handleSubmit = (data) => {
    const prodTimeN = dayjs(data.prodTime, 'h:mm a').valueOf();
    const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
    
    if (ProductctionDetails?.temp === "N/A") {
        // Update mode - existing code
        let formData = JSON.stringify({
            coldTraceabilityTime: prodTimeN,
            coldTraceabilityDate: convertToUnixTimestamp(SelectDate),
            temp: data?.Temperature,
            correctiveAction: Correctvalid ? data?.correctiveAction : '',
            productionDTO: {
                id: ProductctionDetails?.productionDTO?.id,
            },
            storageDTO: {
                id: storageUnit?.id,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
            institutionDTO: {
                id: ProductctionDetails?.institutionDTO?.id,
            },
            quantityOfTheCookedProduct: ProductctionDetails?.quantityOfTheCookedProduct,
        });

        ColdTraceabilityApi.PutColdTraceabiltyApi(ProductctionDetails?.id, formData)
            .then((response) => {
                let formData2 = JSON.stringify({
                    id: storageUnit?.id,
                    name: storageUnit?.name,
                    alertTrigger: storageUnit?.alertTrigger,
                    description: storageUnit?.description,
                    sensorDTOList: storageUnit?.sensorDTOList,
                    temperatureMaxInCelsius: storageUnit?.temperatureMaxInCelsius,
                    temperatureMinInCelsius: storageUnit?.temperatureMinInCelsius,
                    institutionDTO: {
                        id: storageUnit?.institutionDTO?.id,
                    },
                    temperatureDTOList: [{
                        temperatureInCelsius: data?.Temperature,
                        createdDate: prodTimeN,
                        description: ProductctionDetails?.productionName,
                    }],
                    tenantDTO: {
                        id: decodedToken?.tenantId,
                        tenantApiKey: decodedToken?.tenantApiKey,
                    }
                })

                StorageListApi.Putstorage(storageUnit?.id, formData2)
                    .then((response) => {
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                            description: "Update Successfully",
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#b3ffb3",
                                color: "green",
                            },
                        });

                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    })
                    .catch((err) => {
                        if (err.apiError.status) {
                            notification.open({
                                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                                description: err.apiError.message,
                                closeIcon: false,
                                duration: 3,
                                style: {
                                    backgroundColor: "#fff2f0",
                                    color: "red",
                                },
                            });
                        }
                    });
            })
            .catch((err) => {
                console.log(err);
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    } else {
        // Create mode - ADD quantityOfTheCookedProduct here
        let formData = JSON.stringify({
            coldTraceabilityTime: prodTimeN,
            coldTraceabilityDate: convertToUnixTimestamp(SelectDate),
            temp: data?.Temperature,
            correctiveAction: Correctvalid ? data?.correctiveAction : '',
            productionDTO: {
                id: ProductctionDetails?.productionDTO?.id,
            },
            storageDTO: {
                id: ProductctionDetails?.storageDTO?.id,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
            institutionDTO: {
                id: ProductctionDetails?.institutionDTO?.id,
            },
            quantityOfTheCookedProduct: ProductctionDetails?.quantityOfTheCookedProduct, // ADD THIS LINE
        });
        
        ColdTraceabilityApi.Createcoldtraceability(formData)
            .then((response) => {
                let formData2 = JSON.stringify({
                    id: storageUnit?.id,
                    name: storageUnit?.name,
                    alertTrigger: storageUnit?.alertTrigger,
                    description: storageUnit?.description,
                    sensorDTOList: storageUnit?.sensorDTOList,
                    temperatureMaxInCelsius: storageUnit?.temperatureMaxInCelsius,
                    temperatureMinInCelsius: storageUnit?.temperatureMinInCelsius,
                    institutionDTO: {
                        id: storageUnit?.institutionDTO?.id,
                    },
                    temperatureDTOList: [{
                        temperatureInCelsius: data?.Temperature,
                        createdDate: prodTimeN,
                        description: ProductctionDetails?.productionName,
                    }],
                    tenantDTO: {
                        id: decodedToken?.tenantId,
                        tenantApiKey: decodedToken?.tenantApiKey,
                    },
                    quantityOfTheCookedProduct: ProductctionDetails?.quantityOfTheCookedProduct,
                })

                StorageListApi.Putstorage(storageUnit?.id, formData2)
                    .then((response) => {
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                            description: "Update Successfully",
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#b3ffb3",
                                color: "green",
                            },
                        });

                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    })
                    .catch((err) => {
                        if (err.apiError.status) {
                            notification.open({
                                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                                description: err.apiError.message,
                                closeIcon: false,
                                duration: 3,
                                style: {
                                    backgroundColor: "#fff2f0",
                                    color: "red",
                                },
                            });
                        }
                    });
            })
            .catch((err) => {
                console.log(err);
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    }
};

    const currentDate = moment().format("DD/MM/YYYY");


    const handleCancel = () => {
        formAdd.resetFields();

        onClose();
    };
    const handleInput = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            // Remove any non-numeric or extra decimal characters
            e.target.value = value.slice(0, -1);
        }
    };

    const [isRecording, setIsRecording] = useState(false);
    const startRecording = (fieldN) => {

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'en-US';
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            let fieldName = fieldN;

            console.log(transcript)
            formAdd.setFieldsValue({
                [fieldName]: transcript,
            });
        };

        recognition.start();
        if (fieldN === 'Temperature') {
            setIsRecording(true);
        }
    };

    const stopRecording = () => {
        setIsRecording(false);
    };
    return (
        <>
            <Modal
                footer={[]}
                width={700}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Take Temperature {ModalTemptype === 1 ? <>1<sup className="Primary-Font">st</sup></> : <>2<sup className="Primary-Font">nd</sup></>}
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    id="SelectClassPrduction"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass SlectNew IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="my-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <div className="px-2" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b>{formattedTimeNew}</b> <img
                                    src="/assest/Images/time.png"
                                    style={{ width: '35px', marginLeft: '10px' }}
                                    className="logo-png"
                                />

                            </div>
                            <Form.Item
                                name="prodTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable disabled d-none"

                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />
                            </Form.Item>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="disabled text-lable col-lg-6  d-none col-sm-12 col-md-7"


                            >
                                <DatePicker
                                    disabled
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 disabled d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    disabled
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div><div className="Product-createDate">
                            <Form.Item
                                name="createTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 disabled d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />

                            </Form.Item>
                        </div>
                        <StorageSelectColdTrace />



                        <Form.Item
                            name="Temperature"
                            label="Temperature"
                            className="text-lable mt-2"

                        >
                            <Input
                                type="number"
                                onChange={(event) => handleInputChange(event)}
                                placeholder="0"
                                className="control-input col-6"
                                style={{
                                    border: 'none',
                                    textAlign: 'end',
                                    padding: '0px'
                                }}
                                addonAfter={
                                    <>
                                        <Button
                                            className="StockTempClass"
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                paddingTop: '0px',
                                                margin: 0,
                                                background: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            'C
                                        </Button>
                                        <Button
                                            onMouseDown={() => startRecording('Temperature')}
                                            onMouseUp={stopRecording}
                                            onMouseLeave={stopRecording}
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                marginLeft: '10px',
                                                paddingLeft: '5px',
                                                paddingBottom: '5px',
                                                background: 'none',
                                                borderRadius: '0px',
                                                borderLeft: '1px solid #d9d9d9',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                                        </Button>
                                    </>
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            name="institutionID"
                            label="institutionID"
                            className="text-lable d-none"
                        >
                            <Input
                                type="text"
                                onInput={handleInput}
                                className="control-input"
                            />
                        </Form.Item>
                        <Alert message={`Temperature should be between ${storageUnit?.temperatureMinInCelsius} to ${storageUnit?.temperatureMaxInCelsius}`} type="info" className="temp-info-text" />
                        <Form.Item
                            name="correctiveAction"
                            label="Corrective Action"
                            className={Correctvalid ? 'text-lable' : 'd-none'}
                            rules={Correctvalid ? [
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ] : []}
                        >
                            <Input
                                type="text"
                                placeholder="Corrective Action"
                                className="control-input"
                            />
                        </Form.Item>





                        <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                {ProductctionDetails?.temp === "N/A" ? 'Update' : 'Create'}
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div>
                    </>
                </Form>
            </Modal >
        </>
    );
}

export default AddTemp;
